import { render, staticRenderFns } from "./Features.vue?vue&type=template&id=249ffc84&scoped=true&"
import script from "./Features.vue?vue&type=script&lang=ts&"
export * from "./Features.vue?vue&type=script&lang=ts&"
import style0 from "./Features.vue?vue&type=style&index=0&id=249ffc84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249ffc84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VCol,VRow,VSheet,VToolbarTitle})
